import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "order-list",
  name: "订单列表",
  icon: "单",
  group: "国学组件",
  description: "展示近期国学服务订单和消费记录。",
  defaultProps: {
    "title": "近期订单",
    "limit": 5
}
}
